import { getInfo } from '@/api/user'
import { getFulltimeClassByPeriodCode } from '@/api/myclass'
import { getPeriod } from '@/api/teacher'



const user = {
  state: {
    name: '',
    roles: [],
    permissions: [],
    teacher: {},
    businessModes: [],
    aiTutorPermissions: [],
    userId: '',
    userName: '',
    teacherRoleIds: [],

    userTeachClassList: [],
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_TEACHERID: (state, teacherId) => {
      state.teacherId = teacherId
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_BUSINESS_MODES: (state, businessModes) => {
      state.businessModes = businessModes
    },
    SET_TEACHER: (state, teacher) => {
      state.teacher = teacher
    },
    SET_AITUTORPERMISSIONS: (state, aiTutorPermissions) => {
      state.aiTutorPermissions = aiTutorPermissions
    },
    SET_USER_CLASSLIST: (state, userTeachClassList) => {
      state.userTeachClassList = userTeachClassList
    },
    SET_EXPERIENCEFUNCTIONSBLACKLIST: (state, experienceFunctionsBlackList) => {
      state.experienceFunctionsBlackList = experienceFunctionsBlackList
    },
    SET_TEACHER_ROLE_IDS: (state, teacherRoleIds) => {
      state.teacherRoleIds = teacherRoleIds
    },
  },

  actions: {
    // 获取用户信息
    GetInfo: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        if (state.name) {
          const {roles} = state
          resolve({roles})

        } else {
          getInfo().then(response => {
            const data = response;
            commit('SET_PERMISSIONS', data.permissions)
            commit('SET_ROLES', data.roles)
            commit('SET_NAME', data.name)
            commit('SET_TEACHERID', data.teacherId || '')
            commit('SET_USER_ID', data.userId || '')
            commit('SET_BUSINESS_MODES',data.businessModes)
            commit('SET_AITUTORPERMISSIONS',[{code: 'aiChat', name: '青椒助教'}, ...(data.aiTutorPermissions || [])])
            commit('SET_USER_NAME', data.userName)
            commit('SET_EXPERIENCEFUNCTIONSBLACKLIST',data.experienceFunctionsBlackList)
            commit('SET_TEACHER_ROLE_IDS', data.teacherRoleIds || [])
            resolve(response)
          }).catch(error => {
            reject(error)
          })

        }
      })
    },

    // 前端 登出
    FedLogout: ({ commit }) => {
      return new Promise(resolve => {
        commit('SET_NAME', '')
        resolve()
      })
    },

    updateUserClass: async ({commit, state}) => {
      try {
        
        let periodRes = await getPeriod({businessMode: 2})
        console.log('periodRes: ', periodRes);
  
        let currentPeriod = periodRes.find(item => {
          return item.isCurrent
        })  
        
        if (!currentPeriod) {// 老师没有当前学届
          commit('SET_USER_CLASSLIST', [])
          return 
        }
        
        let classRes = await getFulltimeClassByPeriodCode({periodCode: currentPeriod.periodCode})
        console.log('classRes: ', classRes);
        commit('SET_USER_CLASSLIST', [...classRes])
      } catch (error) {
        
      }
      
    }
  }
}

export default user
